import { WorkoutIdsAutoCompleteComponent } from './WorkoutIdsAutoCompleteComponent';

export default WorkoutIdsAutoCompleteComponent;
